module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "posFixed"
  }, [_c('div', {
    staticClass: "posFixed ",
    on: {
      "click": _vm.closePreviewImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "big-img-box"
  }, [(/^(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(_vm.previewImgUrl.split('.').pop())) ? _c('video', {
    attrs: {
      "controls": "controls"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.previewImgUrl,
      "type": "video/mp4"
    }
  })]) : _c('img', {
    attrs: {
      "src": _vm.previewImgUrl,
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b3ee6b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview-image.vue
// module id = prsl
// module chunks = 57